import { Action, combineReducers } from 'redux';
import { ThunkAction } from 'redux-thunk';
import businessInfo, { IBusinessInfoState } from './businessInfo/reducer';
import experiments from './experiments/reducer';
import type { IExperiments } from './experiments/types';
import wrapWithTemporaryInputReducer from './input/wrapWithTemporaryInputReducer';
import media, { IMediaState } from './media/reducer';
import siteMeta from './siteMeta/reducer';
import type { ISiteMetaState } from './siteMeta/reducer';

import videoInfo from './videoInfo/reducer';
import type { IVideoInfoState } from './videoInfo/reducer';

import videoOutput from './videoOutput/reducer';
import type { IVideoOutputState } from './videoOutput/reducer';

import videoStyle from './videoStyle/reducer';
import type { IVideoStyleState } from './videoStyle/reducer';

import videoText from './videoText/reducer';
import type { IVideoTextState } from './videoText/reducer';

import wizardSession from './wizzardSession/reducer';
import type { IWizardSession } from './wizzardSession/reducer';

export interface IRootState {
  wizardSession: IWizardSession;
  videoInfo: IVideoInfoState;
  videoStyle: IVideoStyleState;
  videoText: IVideoTextState;
  businessInfo: IBusinessInfoState;
  media: IMediaState;
  siteMeta: ISiteMetaState;
  videoOutput: IVideoOutputState;
  experiments: IExperiments;
}

// NOTE: All user input should be cleared after wizard flow finished
// TODO: review `USER_INPUT_KEYS` logic when all input will be under 'input' reducer
// https://github.com/wix-private/vmaf/issues/30
const USER_INPUT_KEYS: (keyof IRootState)[] = [
  'videoInfo',
  'media',
  'videoStyle',
  'videoText',
  'businessInfo',
];

export default wrapWithTemporaryInputReducer(
  combineReducers({
    wizardSession,
    videoInfo,
    videoStyle,
    videoText,
    businessInfo,
    media,
    siteMeta,
    videoOutput,
    experiments,
  }),
  USER_INPUT_KEYS,
);

export type Selector<T> = (state: IRootState) => T;
export type SelectorWithProps<T, P> = (state: IRootState, props: P) => T;

export type Thunk<TAction extends Action, TReturn = void> = ThunkAction<
  TReturn,
  IRootState,
  void,
  TAction
>;

export type IMapStateToProps<T = any> = (state: IRootState) => T;
export type IMapDispatchToProps<T> = Record<keyof T, any>;
